module.exports = __webpack_public_path__ + "img/JT_icons01_64px_New.96b50cb9.svg";